import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Link } from "react-router";
import "@/components/NotFound/NotFound.css";

function NotFound() {
  return (
    <Box id="page-not-found-container">
      <img src="/images/ada_face_purple_360.png" alt="ada logo" />
      <Typography variant="h4" color="text.secondary" gutterBottom>
        Apologies!
      </Typography>
      <Typography variant="h5" color="text.secondary">
        Something has gone wrong.
      </Typography>
      <Box className="not-found-button-cont">
        <Link to="/">
          <Button variant="outlined">return home</Button>
        </Link>
      </Box>
    </Box>
  );
}

export default NotFound;
